import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, TextField, InputAdornment, styled, Typography } from '@mui/material';
import esLocale from 'date-fns/locale/es';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { CalendarToday } from '@mui/icons-material';

import { getEndOfWeek, getStartOfWeek } from './auxFunctions';

const StyledTextField = styled(TextField)`
  border-radius: 4px;
  border: 1px solid var(--Blanco, #fff);
  background: #e3edf7;
  box-shadow: 4px 4px 14px 0px #d9d9d9 inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset;
`;

const DateSelector = ({ onChange, selectedDate }) => {
  const [openCalendar, setOpenCalendar] = useState(false);

  return (
    <Box>
      <Typography
        sx={{
          color: '#5B5D71',
          fontFamily: 'Poppins',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: 1.2,
          marginBottom: '9px',
        }}
      >
        Fecha
      </Typography>
      <StyledTextField
        readOnly
        fullWidth
        size="small"
        onClick={() => setOpenCalendar(true)}
        value={`${getStartOfWeek(selectedDate)} - ${getEndOfWeek(selectedDate)}`}
        sx={{
          margin: '0px',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'transparent',
            },
          },
        }}
        InputProps={{
          style: {
            fontFamily: 'Poppins-Regular',
            borderRadius: '4px',
            padding: '10px 15px',
            alignItems: 'center',
            border: '0px',
            color: '#5B5D71',
          },
          startAdornment: (
            <InputAdornment position="end" sx={{ paddingRight: '10px' }}>
              <CalendarToday />
            </InputAdornment>
          ),
        }}
      />

      <LocalizationProvider adapterLocale={esLocale} dateAdapter={AdapterDateFns}>
        <MobileDatePicker
          fullWidth
          disableOpenPicker
          open={openCalendar}
          disableFuture
          componentsProps={{
            actionBar: {
              actions: [],
            },
          }}
          value={selectedDate}
          showDaysOutsideCurrentMonth
          renderInput={() => {
            return null;
          }}
          onChange={(date) => {
            onChange(date);
            setOpenCalendar(false);
          }}
        />
      </LocalizationProvider>
    </Box>
  );
};

DateSelector.propTypes = {
  onChange: PropTypes.func,
  selectedDate: PropTypes.instanceOf(Date),
};

DateSelector.defaultProps = {
  onChange: () => {},
  selectedDate: new Date(),
};

export default DateSelector;
